module.exports = __webpack_public_path__ + "media/application/images/linkedin-346449cac4db077954aab814d738f640.svg";